import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Using TomSelect for multi-select dropdowns
// Docs: https://tom-select.js.org/docs/

export default class extends Controller {
    static values = {
        allowEmptyOption: Boolean,
        plugins: Array,
        create: Boolean,
    }

    connect() {
        const settings = {
            allowEmptyOption: this.allowEmptyOptionValue,
            plugins: this.pluginsValue,
            create: this.createValue,
            createOnBlur: true,
        }

        new TomSelect(this.element, settings)
    }
}
